import React, { Component } from 'react'
// import PropTypes from 'prop-types'

export default class JavascriptES6andBeyondListItem extends Component {
  // static propTypes = {
  //   prop: PropTypes
  // }

  render() {
    return (
      <span>
        I began using Javascript in 2009. At the time it was an immature language which was missing certain common language characteristics, e.g. <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Classes" alt="Javascript classes functionality">classes</a>. You had to know all the gotcha's to be successful. Now the language is mature and robust, infact it is pushing the envelope of what can be done on the web.
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/config/custom-components/JavascriptES6andBeyondListItem.js